
import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Gallery = () => {
const carouselEvents = {
        autoplay: false,
        loop: true,
        margin: 10,
        nav: true,
        dots: true,
         navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        responsive: {
            0: {
                items: 1
            },

            600: {
                items: 3
            },

            1024: {
                items: 4
            },

            1366: {
                items: 4
            },

            1650: {
                items: 4
            }
        }
    };
    return (
        <>
            <div className="banner-header section-padding valign bg-img bg-fixed bg-position-bottom" data-overlay-dark="5" style={{ backgroundImage: `url(img/slider/contactUs.jpg)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 caption text-center">
                            <h1>Events & Conference</h1>
                        </div>
                    </div>
                </div>
                <Link to="#" data-scroll-nav="1" className="mouse smoothscroll"> <span className="mouse-icon">
                    <span className="mouse-wheel"></span> </span>
                </Link>
            </div>

<section class="section-padding bg-white" data-scroll-index="1">
    <div className='container'>
        <div className='col-md-12'>
            <div className="section-title">Events </div>
            <p>At Residency Group Hotels, we host unforgettable weddings, conferences, and events, tailored to your unique needs and preferences. Our experienced team curates bespoke experiences, ensuring every detail is meticulously planned and executed.</p>
            
            <div className="section-title">We Host </div>
            <ul>
                <li><strong>Weddings</strong>: Fairytale weddings, intimate gatherings, or grand celebrations – we make your special day truly unforgettable.</li>
                <li><strong>Conferences</strong>: Professional conferences, seminars, and workshops – our state-of-the-art facilities and expert team ensure a successful event.</li>
                <li><strong>Events</strong>: Corporate events, parties, and social gatherings – we create memorable experiences that exceed your expectations.</li>
               
            </ul>
            <p>Whether you're planning a wedding, conference, or social gathering, our team is dedicated to making your event a success. Contact us to discuss your ideas and let us create an unforgettable experience for you and your guests.</p>
           
        </div>
    </div>
        <div class="container">
            <div className="section-title">Marriage </div>
            <div class="row">
                <OwlCarousel className="owl-theme first-carousel" {...carouselEvents}>
                     <div className='item'>
                        <a href="img/events/Marriage.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-a.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-a.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                     <div className='item'>
                        <a href="img/events/Marriage-1.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-1.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-2.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-2.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    
                     <div className='item'>
                        <a href="img/events/Marriage-3.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-3.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-4.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-4.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-5.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-5.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-6.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-6.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-7.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-7.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-8.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-8.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-9.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-9.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-10.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-10.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-11.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-11.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-12.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-12.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-13.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-13.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-14.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-14.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-15.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-15.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-16.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-16.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-17.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-17.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-18.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-18.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                     <div className='item'>
                        <a href="img/events/Marriage-19.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Marriage-19.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>

                </OwlCarousel>
            </div>
        </div>
         <div class="container">
            <div className="section-title">Corporate</div>
            <div class="row">
                 <OwlCarousel className="owl-theme first-carousel" {...carouselEvents}>                    
                    <div className='item'>
                        <a href="img/events/Corporate.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Corporate.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                   
                    <div className='item'>
                        <a href="img/events/Corporate-2.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Corporate-2.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                   
                    <div className='item'>
                        <a href="img/events/Corporate-4.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Corporate-4.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate-5.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Corporate-5.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate-6.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Corporate-6.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>
                    <div className='item'>
                        <a href="img/events/Corporate-7.jpg" title="" class="img-zoom">
                            <div class="img-block">
                                <div class="wrapper-img"> 
                                    <img src="img/events/Corporate-7.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                     </div>                              
                            </div>
                        </a>                        
                    </div>

                </OwlCarousel>
            </div>
        </div>
        
         
    </section>


<section class="section-padding" data-scroll-index="1">
        <div class="container">
            <div className="section-title">Video</div>
             <div className="row">
                                    <OwlCarousel className="owl-theme first-carousel" {...carouselEvents}>
                                        {[1, 3, 4, 12].map((num) => (
                                            <div className="item" key={num}>
                                                <video
                                                    width="100%"
                                                    height="auto"
                                                    controls
                                                    preload="metadata"
                                                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                                >
                                                    <source src={`videos/video-${num}.mp4`} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                        ))}
                                    </OwlCarousel>
                                </div>
        </div>
    </section>

    
 

        </>
    )
};

export default Gallery;
